export enum ContainerEvents {
  Blur = 'blur',
  Focus = 'focus',
  Resize = 'resize',
  Scroll = 'scroll',
  FullscreenChange = 'fullscreenchange',
  OrientationChange = 'orientationchange',
  VisibilityChange = 'visibilitychange'
}
